// extracted by mini-css-extract-plugin
export default {"title":"box_title__yARtG","speed":"box_speed__TzDuh","value":"box_value__ndzO+"};